import { createSelector } from 'reselect'
import generateFilterModule from './generateFilterModule'

const selectFilters = state => state.attendee.filterSettings.speakers.data

export const filtersSelector = createSelector(selectFilters, filters => filters)

export default generateFilterModule('speakers')
